var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPresent3DSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Present3D_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3.1 16.38 15.1 22.23 15.1 16.07 3.1 10.07 3.1 16.38"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28.15 8.28 22.56 5.51 20.65 4.57 16 2.27 11.35 4.63 9.29 5.67 3.85 8.43 15.1 13.98 16 14.43 16.9 13.97 28.15 8.28"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.9 29.57 28.9 23.73 28.9 18.93 16.9 24.93 16.9 29.57"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3.1 23.88 15.1 29.73 15.1 24.93 3.1 18.93 3.1 23.88"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.9 22.07 28.9 16.23 28.9 9.93 16.9 15.78 16.9 22.07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent3DSvg);
export default __webpack_public_path__ + "static/media/Present3D_svg.c9934f7638a2647d0ffb2beeece4def3.svg";
export { ForwardRef as ReactComponent };